import { useMutation, type UseMutationResult } from '@tanstack/react-query'

import { graphql_call as graphql_admin_call } from '../../schemas/server_admin_query'

import { mutation_update_external_financial_account } from './external_financial_graphql'

export type UpdateExternalFinancialAccountRequest = {
  id: string
  current_balance: number
  available_balance: number
}

export type UpdateExternalFinancialAccountPayload = {
  external_financial_account: {
    id: string
    name: string
    current_balance: number
    available_balance: number
    currency: string
    custodian: string
    updated_at: string
    updated_by: string
    fund_id: string | null
  } | null
  external_financial_balance_update: {
    id: string
    old_balance: number
    new_balance: number
    updated_by: string
    created_at: string
  } | null
  errors: string[]
}

export function useUpdateExternalFinancialAccount(): UseMutationResult<
  UpdateExternalFinancialAccountPayload,
  Error,
  UpdateExternalFinancialAccountRequest
> {
  return useMutation({
    mutationFn: async (
      request: UpdateExternalFinancialAccountRequest,
    ): Promise<UpdateExternalFinancialAccountPayload> => {
      const response = await graphql_admin_call({
        query: mutation_update_external_financial_account,
        variables: {
          id: request.id,
          current_balance: request.current_balance,
          available_balance: request.available_balance,
        },
      })

      if (!response) {
        throw new Error('Failed to update external financial account')
      }

      return response
    },
  })
}
